import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AdvisorsComponent } from 'src/app/administration/advisors/advisors.component';
import { UserManagement } from 'src/services/api-services/api-interfaces/userManagement.interface';
import { APIUserManagamentService } from 'src/services/api-services/api-user-Management';
import { User } from 'src/models/user';
import { HelperService } from 'src/services/helperService';
import { CustomerBasicDataEdit } from 'src/services/api-services/api-interfaces/customerBasicData.interface';
import { APICustomerBasicDataService } from 'src/services/api-services/api-customer-basic-data-service';
import { Message } from '../../../../../services/api-services/api-interfaces/message.interface';

@Component({
    selector: 'app-delete-clients',
    templateUrl: './delete-clients.dialog.html',
    styleUrls: ['./delete-clients.dialog.sass'],
    standalone: false
})
export class DeleteClientDialog implements OnInit {

  isLoadingSave=true;
  user:User= this.helperService.user

  constructor(
    public dialogRef: MatDialogRef<AdvisorsComponent>,
    public userManagamentService: APIUserManagamentService,
    private translate: TranslateService,
    public helperService: HelperService,
    public customerBasicDataService: APICustomerBasicDataService,
    @Inject(MAT_DIALOG_DATA)
    public client: CustomerBasicDataEdit,
  ) { }


  ngOnInit(): void {

  }

  onSave(): void {
    this.isLoadingSave=false

    if (this.client.CustomerId) {

      const customerId = Number(this.client.CustomerId);
      if (!isNaN(customerId)) {
        this.customerBasicDataService.deleteCustomer(customerId).subscribe({next:  (response) => {

          if (response.code === "200") {
            const translateTextSuccess = this.translate.instant("ToastSuccessDeleteUser", { User: this.client.FirstName + " " + this.client.LastName });

            this.helperService.showAlert =true
            this.helperService.typeAlert ="success"
            this.helperService.messageAlert =translateTextSuccess

            setTimeout(() => {
              this.helperService.showAlert =false

              }, 7000)

          } else {
            const translateTextError = this.translate.instant("ToastErrorDeleteUser", { User: this.client.FirstName + " " + this.client.LastName });
            this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTextError

            setTimeout(() => {
              this.helperService.showAlert =false

              }, 7000)
          }

          this.isLoadingSave = true;
          this.dialogRef.close("refreshCustomer");
        },
          error: (failed) => {
            // Validation 401 error
            if(failed.status === 401){
              this.helperService.logoutToken()
            }

            console.log(failed);
            const translateTextError = this.translate.instant("ToastDeleteClientWithAppointment");
            this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTextError

            setTimeout(() => {
              this.helperService.showAlert =false
              }, 7000)
            this.dialogRef.close();
          },
        });
      } else {
        console.error("CustomerId is not a valid number.");
      }
    } else {
      console.error("CustomerId is undefined.");
    }
  }

  onCancel(): void {
    this.dialogRef.close();

  }

}
